// =============================================================================
// SIREPPAR - Dataset de feriados nacionales y provinciales de Chubut
// =============================================================================
//
// MANTENIMIENTO:
// Cada diciembre, agregar el año siguiente al objeto MOVIBLES con:
//   - Lunes y martes de Carnaval (48 y 47 días antes de Pascua)
//   - Jueves y Viernes Santo
//   - San Martín (17-ago trasladado al lunes más cercano)
//   - Diversidad Cultural (12-oct trasladado al lunes más cercano)
//   - Soberanía Nacional (4º lunes de noviembre)
//   - Asuetos administrativos que declare el PEN o la provincia
//
// Fuente: Decreto del Poder Ejecutivo Nacional + resoluciones provinciales de Chubut.
// Los feriados fijos (FIJOS) no requieren actualización anual.
// El 10-26 (Día de la Provincia del Chubut) es provincial y no figura en decretos nacionales.
// =============================================================================


const FIJOS: string[] = [
    '01-01', // Año Nuevo
    '03-24', // Día Nacional de la Memoria
    '04-02', // Día del Veterano y los Caídos en Malvinas
    '05-01', // Día del Trabajador
    '05-25', // Revolución de Mayo
    '06-17', // Güemes
    '06-20', // Belgrano
    '07-09', // Independencia
    '10-26', // Día de la Provincia del Chubut (provincial)
    '12-08', // Inmaculada Concepción
    '12-25', // Navidad
  ]
  
  const MOVIBLES: Record<number, string[]> = {
    2024: [
      '2024-02-12', '2024-02-13', // Carnaval
      '2024-03-28',               // Jueves Santo
      '2024-03-29',               // Viernes Santo
      '2024-10-14',               // Diversidad Cultural (12-oct sáb → lun 14)
      '2024-11-25',               // Soberanía Nacional (4º lunes de nov)
    ],
    2025: [
      '2025-03-03', '2025-03-04', // Carnaval
      '2025-04-17',               // Jueves Santo
      '2025-04-18',               // Viernes Santo
      '2025-08-18',               // San Martín (17-ago dom → lun 18)
      '2025-10-13',               // Diversidad Cultural (12-oct dom → lun 13)
      '2025-11-24',               // Soberanía Nacional (4º lunes de nov)
    ],
    2026: [
      '2026-02-16', '2026-02-17', // Carnaval
      '2026-04-02',               // Jueves Santo (coincide con Día de Malvinas)
      '2026-04-03',               // Viernes Santo
      '2026-08-17',               // San Martín (17-ago lun ✓)
      '2026-10-12',               // Diversidad Cultural (12-oct lun ✓)
      '2026-11-23',               // Soberanía Nacional (4º lunes de nov)
    ],
    2027: [
      '2027-02-08', '2027-02-09', // Carnaval
      '2027-03-25',               // Jueves Santo
      '2027-03-26',               // Viernes Santo
      '2027-08-16',               // San Martín (17-ago mar → lun 16)
      '2027-10-11',               // Diversidad Cultural (12-oct mar → lun 11)
      '2027-11-22',               // Soberanía Nacional (4º lunes de nov)
    ],
  }
  
  const cache = new Map<number, Set<string>>()
  
  function getFeriadosDelAnio(year: number): Set<string> {
    if (cache.has(year)) return cache.get(year)!
    const s = new Set<string>()
    for (const mmdd of FIJOS) s.add(`${year}-${mmdd}`)
    for (const fecha of MOVIBLES[year] ?? []) s.add(fecha)
    cache.set(year, s)
    return s
  }
  
  export function esFeriado(fecha: Date): boolean {
    const yyyy = fecha.getFullYear()
    const mm = String(fecha.getMonth() + 1).padStart(2, '0')
    const dd = String(fecha.getDate()).padStart(2, '0')
    return getFeriadosDelAnio(yyyy).has(`${yyyy}-${mm}-${dd}`)
  }

  export const ANIOS_CUBIERTOS = Object.keys(MOVIBLES).map(Number)